(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    const navigation = document.querySelector('.header__inline-menu');

    if (!navigation) return;

    const announcement = document.querySelector('.announcement-bar-section');
    const syncAnnouncementHeight = () => {
      const height = announcement ? Math.ceil(announcement.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--tcc-announcement-height', `${height}px`);
    };

    syncAnnouncementHeight();
    window.addEventListener('resize', syncAnnouncementHeight, { passive: true });

    if (announcement && 'ResizeObserver' in window) {
      const announcementObserver = new ResizeObserver(syncAnnouncementHeight);
      announcementObserver.observe(announcement);
    }

    const menus = Array.from(navigation.querySelectorAll('header-menu > details.mega-menu'));
    const closeTimers = new WeakMap();

    const syncBackdrop = () => {
      const anyOpen = menus.some((details) => details.hasAttribute('open'));
      document.body.classList.toggle('tcc-mega-open', anyOpen);
    };

    const setMenuState = (details, isOpen) => {
      const summary = details.querySelector(':scope > summary');

      if (isOpen) {
        details.setAttribute('open', '');
      } else {
        details.removeAttribute('open');
      }

      if (summary) summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      syncBackdrop();
    };

    const cancelScheduledClose = (details) => {
      const timer = closeTimers.get(details);
      if (!timer) return;
      window.clearTimeout(timer);
      closeTimers.delete(details);
    };

    const closeOtherMenus = (activeMenu) => {
      menus.forEach((details) => {
        if (details === activeMenu) return;
        cancelScheduledClose(details);
        setMenuState(details, false);
      });
    };

    menus.forEach((details) => {
      details.addEventListener('mouseenter', () => {
        if (!desktopHover.matches) return;

        cancelScheduledClose(details);
        closeOtherMenus(details);
        setMenuState(details, true);
      });

      details.addEventListener('mouseleave', () => {
        if (!desktopHover.matches) return;

        cancelScheduledClose(details);
        const timer = window.setTimeout(() => {
          setMenuState(details, false);
          closeTimers.delete(details);
        }, 110);
        closeTimers.set(details, timer);
      });

      details.addEventListener('toggle', syncBackdrop);
    });

    document.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape') return;
      menus.forEach((details) => {
        cancelScheduledClose(details);
        setMenuState(details, false);
      });
    });

    desktopHover.addEventListener('change', (event) => {
      if (event.matches) return;
      menus.forEach((details) => {
        cancelScheduledClose(details);
        setMenuState(details, false);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
